/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const membershipResponseOutputIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const membershipResponseOutputTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const membershipResponseOutputUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const membershipResponseOutputDisplayNameMax = 200;

export const membershipResponseOutputStartedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const membershipResponseOutputEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const membershipResponseOutputVersionExclusiveMin = 0;
export const membershipResponseOutputVersionMax = 9007199254740991;

export const MembershipResponseOutput = zod.object({
  id: zod.uuid().regex(membershipResponseOutputIdRegExp),
  teamId: zod.uuid().regex(membershipResponseOutputTeamIdRegExp),
  userId: zod.uuid().regex(membershipResponseOutputUserIdRegExp),
  displayName: zod.string().min(1).max(membershipResponseOutputDisplayNameMax),
  startedAt: zod.iso.datetime({ offset: true }).regex(membershipResponseOutputStartedAtRegExp),
  endedAt: zod.union([
    zod.iso.datetime({ offset: true }).regex(membershipResponseOutputEndedAtOneRegExp),
    zod.null(),
  ]),
  version: zod
    .int()
    .gt(membershipResponseOutputVersionExclusiveMin)
    .max(membershipResponseOutputVersionMax),
  teamActive: zod.boolean(),
  effective: zod.boolean(),
});

export type MembershipResponseOutput = zod.input<typeof MembershipResponseOutput>;
export type MembershipResponseOutputOutput = zod.output<typeof MembershipResponseOutput>;
